import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { IBlog } from 'src/app/shared/models/Iblog';
import { BlogService } from 'src/app/shared/services/blog.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  listBlogs: IBlog[];
  showModal = false;
  name = '';
  email = '';
  downloadUrl: string = '';

  constructor(private _blogService: BlogService, private http: HttpClient) { }

  ngOnInit(): void {
    this._blogService.getBlogs().subscribe((data: IBlog[]) => {
      this.listBlogs = data;
    }, error => {
      console.error('Error fetching blogs:', error);
    });
  }


  openModal(url: string) {
    const suscripcion = localStorage.getItem("descarga_informe");
    if (suscripcion) {
      window.open(url, '_blank');
    } else {
      this.showModal = true;
      this.downloadUrl = url;
    }

  }
  
  closeModal() {
    this.showModal = false;
  }

  onSubmit() {
    const data = {
      name: this.name,
      email: this.email
    };
    const suscripcion = localStorage.getItem("descarga_informe");
    if (suscripcion) {
      window.open(this.downloadUrl, '_blank');
    } else {
      this.http.post('https://qhapi.qairadrones.com/api/send_suscripcion', data).subscribe({
        next: res => {
          this.closeModal();
          window.open(this.downloadUrl, '_blank');
          this.email = "";
          this.name = "";
          localStorage.setItem("descarga_informe", "ok")
        },
        error: err => {
          console.error('Error', err);
        }
      });
    }

  }


}
